module.exports = __webpack_public_path__ + "assets/img/zhijiaob_5013_1.57f9d6a4.jpg";